<tc-manage-supplier-attributes
        [supplierAttributes]="supplierAttributes"
        (attributesChanged)="onSupplierAttributesChanged($event)">
</tc-manage-supplier-attributes>
<div class="payment__actions">
    <button class="button-right tc-button-primary mat-button" (click)="closeModalClick()">
        {{'Ok' | translate}}
    </button>
</div>
